import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/AppLayout";
import { AgentAvatar } from "@/components/Badges";
import { Card } from "@/components/ui/card";

export default function Agents() {
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/agents").then((r) => setData(r.data)); }, []);

  if (!data) return <div className="p-8 text-muted-foreground">Chargement…</div>;

  const byPole = {};
  data.agents.forEach((a) => { (byPole[a.pole] = byPole[a.pole] || []).push(a); });

  return (
    <>
      <PageHeader title="Annuaire des agents" subtitle="26 agents spécialisés + SG CORE, organisés en 7 pôles" />
      <div className="p-8 space-y-10">
        {data.poles.map((pole) => (
          byPole[pole] ? (
            <section key={pole} data-testid={`pole-${pole}`}>
              <div className="flex items-center gap-3 mb-4">
                <div className="h-1 w-8 bg-gold" />
                <h2 className="font-heading text-lg font-semibold text-navy">{pole}</h2>
                <span className="text-xs text-muted-foreground">{byPole[pole].length} agent(s)</span>
              </div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {byPole[pole].map((a) => (
                  <Card key={a.key} className="rounded-sm border-border shadow-none p-4 hover:border-navy transition-colors animate-fade-up" data-testid={`agent-card-${a.key}`}>
                    <div className="flex items-start gap-3">
                      <AgentAvatar agentKey={a.key} size={44} />
                      <div className="min-w-0">
                        <h3 className="font-heading font-bold text-navy leading-tight">{a.name}</h3>
                        <p className="text-[11px] text-muted-foreground uppercase tracking-wide">{a.pole}</p>
                      </div>
                    </div>
                    <p className="text-sm text-slate-600 mt-3 leading-relaxed">{a.mission}</p>
                    <div className="mt-3 pt-3 border-t border-border">
                      <p className="text-[10px] uppercase tracking-wide text-muted-foreground font-semibold mb-1">Bloc-résumé</p>
                      <p className="text-[11px] text-slate-500 font-mono leading-snug">{a.resume.join(" · ")}</p>
                    </div>
                  </Card>
                ))}
              </div>
            </section>
          ) : null
        ))}
      </div>
    </>
  );
}
